import { useMemo } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const SortWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

const Icon = styled.i`
  width: 9px;
  height: 9px;
  display: flex;
  align-items: center;

  color: ${props =>
    props.highlight === 'true'
      ? themeGet('colors.primary.100')
      : themeGet('colors.black.80')};

  &:hover {
    color: ${themeGet('colors.black.60')};
  }
`;

const defaultAsc = {
  icon: 'fa-solid fa-chevron-up fa-2xs',
  id: 'up',
  highlight: 'false',
};

const defaultDesc = {
  icon: 'fa-solid fa-chevron-down fa-2xs',
  id: 'down',
  highlight: 'false',
};

const props = {
  '': [defaultAsc, defaultDesc],
  DESC: [{ ...defaultAsc, highlight: 'true' }, defaultDesc],
  ASC: [defaultAsc, { ...defaultDesc, highlight: 'true' }],
};

const currentSortDirection = ({ columnName, sortingStatus }) =>
  sortingStatus.sortBy === columnName ? sortingStatus.sortDirection : '';

const Sort = ({ sortingStatus, columnName }) => {
  const sortingProps = useMemo(() => {
    const currentSort = currentSortDirection({ sortingStatus, columnName });
    return props[currentSort] ? props[currentSort] : props[''];
  }, [columnName, sortingStatus]);

  return (
    <SortWrapper>
      {sortingProps.map(({ id, icon, highlight }) => (
        <Icon className={icon} key={id} highlight={highlight}></Icon>
      ))}
    </SortWrapper>
  );
};

export default Sort;
